import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { IonButton, IonIcon, ModalController } from '@ionic/angular/standalone';
import { TranslateModule } from '@ngx-translate/core';
import { ClickStopPropagationDirective } from '@okcargo-apps/ng-utils';
import { IFreightBasicForCarrier } from '@okcargo-apps/shared-domain';
import { ConnectivityService } from '@okcargo-apps/shared-infrastructure';
import { FreightCarrierAssignationModalComponent } from '../freight-carrier-assignation-modal/freight-carrier-assignation-modal.component';

@Component({
  selector: 'lib-freight-carrier-assignation-button',
  templateUrl: './freight-carrier-assignation-button.component.html',
  styleUrls: ['./freight-carrier-assignation-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IonIcon, IonButton, ClickStopPropagationDirective, TranslateModule],
})
export class FreightCarrierAssignationButtonComponent {
  public readonly freight = input.required<IFreightBasicForCarrier>();
  /** 'assign' when there is nothing assigned yet, 'modify' when editing an existing assignation. */
  public readonly mode = input<'assign' | 'modify'>('assign');

  private readonly modalCtrl = inject(ModalController);
  private readonly connectivity = inject(ConnectivityService);

  /** Assigning is a command: it cannot be done without connection. */
  public readonly isOffline = this.connectivity.isOffline;

  public async assignDriverAndVehicles(): Promise<void> {
    if (this.isOffline()) return;

    const modal = await this.modalCtrl.create({
      component: FreightCarrierAssignationModalComponent,
      componentProps: { freight: this.freight() },
      backdropDismiss: false,
    });
    modal.present();
  }
}
